// src/screens/sales/document/components/list/item/Item.tsx
import { useSelector } from 'react-redux'
import { DocumentInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import { FaDownload } from 'react-icons/fa6'
import { FaFilePdf, FaFileWord, FaFileExcel, FaFileImage, FaFile } from 'react-icons/fa6'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'

type Props = {
  el: DocumentInterface
  startEdit: (el: DocumentInterface) => void
  showDetails: (el: DocumentInterface) => void
  onDownload: (el: DocumentInterface) => void
  previewUrl?: string
}

export const Item = ({ el, startEdit, showDetails, onDownload, previewUrl }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  const isImage = el.mimeType?.startsWith('image/')
  const isPdf = el.mimeType === 'application/pdf'
  const isDoc =
    el.mimeType === 'application/msword' ||
    el.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  const isXls =
    el.mimeType === 'application/vnd.ms-excel' ||
    el.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

  const FileIcon = isPdf
    ? FaFilePdf
    : isDoc
      ? FaFileWord
      : isXls
        ? FaFileExcel
        : isImage
          ? FaFileImage
          : FaFile

  const iconColor = isPdf
    ? '#e53935'
    : isDoc
      ? '#1e88e5'
      : isXls
        ? '#43a047'
        : isImage
          ? '#8e24aa'
          : '#757575'

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        {isImage && previewUrl ? (
          <img className={classes.image} src={previewUrl} alt={el.name} />
        ) : (
          <FileIcon className={classes.icon} color={iconColor} />
        )}

        <div className={classes.nameAndDescription}>
          <div className={classes.name}>{shortenText(el.name, 50)}</div>
          <div className={classes.description}>{shortenText(el.description, 100)}</div>
        </div>

        {el.links?.[0]?.sortOrder ? (
          <div className={classes.sort}>{el.links[0].sortOrder}</div>
        ) : null}
      </div>

      <div className={classes.buttons}>
        <IconButton display onClick={() => onDownload(el)} icon={FaDownload} alt="Скачать" small />
        <IconButton display onClick={() => showDetails(el)} icon={search} alt="Детали" small />
        <IconButton display onClick={() => startEdit(el)} icon={edit} alt="Изменить" small />
      </div>
    </div>
  )
}
